<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="KeHuList" data-title="交易记录"></div>
    <div
      class="content c-table-box mt-2 !overflow-y-auto flex flex-col gap-y-3"
      v-if="state.list_data?.length > 0"
    >
      <div
        class="bg-white p-4 rounded-lg"
        v-for="item in state.list_data"
        :key="item"
        @click="
          state.selectId = item.id;
          state.showDetail = true;
        "
      >
        <ul class="flex gap-x-2 pb-2 border-b border-gray-100">
          <strong class="text-green-700 cursor-pointer hover:underline">
            {{ item.number }}
          </strong>
          <c_cell
            :size="12"
            title="所属会议"
            :value="item.meeting?.name + '[' + item.meeting?.number + ']'"
          />
          <c_cell
            :size="12"
            title="会议日期"
            :value="item.meeting?.start_date + ' ~ ' + item.meeting?.end_date"
          />
        </ul>
        <ul class="flex items-center gap-x-3 mt-2">
          <c_cell
            title="金额"
            :size="12"
            :value="$priceFormat(item.amount)"
            value-class="text-orange-400 font-bold"
          />
          <c_cell
            title="已收"
            :size="12"
            :value="$priceFormat(item.collected_amount)"
            value-class="text-orange-400 font-bold"
          />
          <c_cell
            title="欠款"
            :size="12"
            :value="$priceFormat(item.uncollected_amount)"
            value-class="text-red-500 font-bold"
          />
          <c_cell title="款项说明" :size="12" :value="item.intro" />
        </ul>
      </div>
    </div>
    <div class="text-center" v-else>
      <el-image :src="require('@/assets/images/nodata.png')" />
    </div>
  </div>
  <el-dialog
    v-model="state.showDetail"
    title="收款详情"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    width="40%"
  >
    <c_detail :id="state.selectId" @close="state.showDetail = false" />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { customer_collected_plan_page } from "@/http/customer";

import c_detail from "./Detail.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    customer_id: Number,
  },
  components: {
    c_detail,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.customer_id = props.customer_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      customer_collected_plan_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
